document.addEventListener("DOMContentLoaded", function () {
    const variantLabels = document.querySelectorAll("label.opt-label"); // Target correct label elements

    if (variantLabels.length === 0) {
        console.log("No variant labels found.");
        return;
    }

    console.log("Variant Labels Found:", variantLabels);

    // Fetch product data correctly
    fetch(window.location.pathname + ".json")
        .then(response => response.json())
        .then(data => {
            console.log("Product Variants Data:", data.product.variants); // Log variant data for debugging

            variantLabels.forEach(label => {
                const variantSpan = label.querySelector(".js-value"); // Locate the variant text inside the label
                if (!variantSpan) return;

                const variantTitle = variantSpan.textContent.trim(); // Get variant name
                const variant = data.product.variants.find(v => v.title === variantTitle);

                if (variant) {
                    console.log(`Variant: ${variantTitle}, Inventory: ${variant.inventory_quantity}, Policy: ${variant.inventory_policy}`);

                    // Determine stock status and update label text
if (variant.inventory_quantity === 0 && variant.inventory_policy === "continue") {
    label.classList.add("variant-unavailable");
    variantSpan.setAttribute("data-stock-status", "(Out of Stock)");
} else if (variant.inventory_quantity > 0) {
    variantSpan.setAttribute("data-stock-status", "(In-Stock)");
}
                }
            });
        })
        .catch(error => console.error("Error fetching variant data:", error));
});
